module.exports = __webpack_public_path__ + "img/woman-banner.7477edf1.png";